<template>
  <div>
    <div
      v-if="loading"
      class="col-md-12 text-center"
      style="margin-top:25%"
    >
      <PulseLoader
        :loading="loading"
      ></PulseLoader>
    </div>
    <div v-if="!loading">
      <div class="row">
        <div class="col-md-12 col-sm-12 ">
          <div class="">
            <div class="x_panel">
              <h2 class="float-left">Main Component List</h2>
              <ul class="nav navbar-right panel_toolbox align-right">
                <li>
                  <button v-if="isPermissionExist(PERMISSIONS.MAIN_COMPONENT_CREATE)" type="button" class="btn btn-info btn-sm" @click="create">Add New <i class="fa fa-plus"></i></button>
                </li>
                <li  v-if="isPermissionExist(PERMISSIONS.MAIN_COMPONENT_PRINT)">
                  <button
                    @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                    <i class="fa fa-print" v-if="!isPrinting"></i>
                    <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                    {{ isPrinting ? 'Printing...' : 'Print' }}
                  </button>
                </li>
                <li  v-if="isPermissionExist(PERMISSIONS.MAIN_COMPONENT_PRINT)">
                  <vue-excel-xlsx
                    ref="excel"
                    :data="excelData"
                    :columns="excelHeader"
                    :file-name="'Main Component List'"
                    :file-type="'xlsx'"
                    :sheet-name="'sheetname'"
                    :disabled="isPrinting"
                    class="btn btn-primary btn-sm float-right"
                  >
                    <div
                      @click.prevent="handleExportPrint('excel')"
                    >
                      <i class="fa fa-file-excel-o"></i>
                      {{ isPrinting ? 'Preparing...' : 'Excel' }}
                    </div>
                  </vue-excel-xlsx>
                </li>
                <li>
                  <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                </li>
              </ul>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="col-md-2 col-6">
                        <div class="form-group">
                          <label for="">Department</label>
                          <select v-model="departmentId" name="department_id" class="form-control">
                            <option value selected>Select Department</option>
                            <option v-for="sdepartment in departments" :key="sdepartment.id" :value="sdepartment.id">{{ sdepartment.name }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-2 col-6 ">
                        <div class="form-group">
                          <label for="">Search </label>
                          <input type="text" v-model="searchInput" placeholder="Enter component name or code" name="searchInput" class="form-control">
                        </div>
                      </div>
                      <div class="col-md-2 mt-2">
                        <div class="form-group">
                          <label for=""></label>
                          <button class=" mt-3 btn-info btn btn-sm" @click="getData()">Search</button>
                        </div>
                      </div>
                    </div>

                    <div>
                      <label>Showing:</label>
                      <select
                        class="form-select mx-2"
                        style="width:120px"
                        v-model="offset"
                        @change="onPerPageChange"
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <label>entries</label>
                    </div>
                    <div class="card-box table-responsive">
                      <p class="text-muted font-13 m-b-30"></p>
                      <table :class="getTableClasses" style="width:100%">
                        <thead>
                        <tr>
                          <th>#</th>
                          <th> Main Component</th>
                          <th>Department Name</th>
                          <th>Code</th>
                          <th>Critical Equipment</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(smainComponent , index) in mainComponent?.data" :key="smainComponent?.id">
                          <td>  {{ (mainComponent?.current_page - 1) * mainComponent?.per_page + index + 1 }}</td>
                          <td>{{smainComponent?.name}}</td>
                          <td>{{smainComponent?.department?.name}}</td>
                          <td>{{smainComponent?.code}}</td>
                          <td>
                            <span class="badge badge-success" v-if="smainComponent?.critical_equipment == 1">
                              Yes
                            </span>
                            <span v-else class="badge badge-danger">
                              No
                            </span>
                          </td>
                          <td>{{smainComponent?.status == 'Activate' ? 'Active' : 'Inactive'}}</td>
                          <td>
                            <button v-if="isPermissionExist(PERMISSIONS.MAIN_COMPONENT_EDIT)" type="button" @click="edit(smainComponent)" class="btn btn-primary btn-sm">
                              <i class="fa fa-edit"></i>
                            </button>
                            <button v-if="isPermissionExist(PERMISSIONS.MAIN_COMPONENT_DELETE) && false" type="button" @click="destroy(smainComponent)" class="btn btn-danger btn-sm">
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <Pagination :pagination="mainComponent" :getData="getData"  />

                      <div id="printArea" style="display: none">
                        <div style="text-align: center;line-height: 20px;">
                          <h2 style="line-height: 10px;">{{ appName }}</h2>
                          <h4 style="line-height: 10px;">Vessel Name: {{this.vesselName}}</h4>
                          <div style="line-height: 10px;" class="font-weight-bold">Main Component List</div>
                          <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                          <table :class="getTableClasses" style="width:100%">
                            <thead>
                            <tr>
                              <th>#</th>
                              <th> Main Component</th>
                              <th>Department Name</th>
                              <th>Code</th>
                              <th>Critical Equipment</th>
                              <th>Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(smainComponent , index) in printItems" :key="smainComponent?.id">
                              <td>  {{ index + 1 }}</td>
                              <td>{{smainComponent?.name}}</td>
                              <td>{{smainComponent?.department?.name}}</td>
                              <td>{{smainComponent?.code}}</td>
                              <td>
                            <span class="badge badge-success" v-if="smainComponent?.critical_equipment == 1">
                              Yes
                            </span>
                                <span v-else class="badge badge-danger">
                              No
                            </span>
                              </td>
                              <td>{{smainComponent?.status == 'Activate' ? 'Active' : 'Inactive'}}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div
        class="modal fade" id="roleModal" tabindex="-1" role="dialog" aria-labelledby="customerModalLongTitle" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="customerModalLongTitle">{{ editMode ? 'Edit' : 'Add ' }} Main Component</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="editMode ? update() : store()" @keydown="form.onKeydown($event)">
              <div class="modal-body">
                <alert-error :form="form"></alert-error>

                <div class="form-group">
                  <label>Department Name</label>
                  <select v-model="form.department_id" name="department_id" class="form-control" :class="{ 'is-invalid': form.errors.has('department_id') }">
                    <option value="" selected>Select department</option>
                    <option v-for="sdepartment in departments" :key="sdepartment.id" :value="sdepartment.id">{{ sdepartment.name }}</option>
                  </select>
                  <has-error :form="form" field="department_id"></has-error>
                </div>

                <div class="form-group">
                  <label> Name</label>
                  <input autocomplete="off" v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                  <has-error :form="form" field="name"></has-error>
                </div>

                <div class="form-group">
                  <label> Code</label>
                  <input autocomplete="off" v-model="form.code" type="text" name="code" class="form-control" :class="{ 'is-invalid': form.errors.has('code') }">
                  <has-error :form="form" field="code"></has-error>
                </div>

                <div class="form-group">
                  <input id="criticalEquipment" autocomplete="off" v-model="form.critical_equipment" type="checkbox" name="code" class="mx-2" :class="{ 'is-invalid': form.errors.has('critical_equipment') }">
                  <has-error :form="form" field="critical_equipment"></has-error>
                  <label for="criticalEquipment">Critical Equipment </label>
                </div>

                <div class="form-group">
                  <label>Status</label>
                  <select v-model="form.status" name="status" class="form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                    <option value="Activate">Activate</option>
                    <option value="Deactivate">Deactivate</option>
                  </select>
                  <has-error :form="form" field="status"></has-error>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="form.busy" type="submit" class="btn btn-info">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Modal -->
    </div>
  </div>
</template>

<script>
    import auth from '../../auth'
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import Pagination from "@/components/Pagination/Pagination.vue";
    import {apiPrintData} from "@/utils/print";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import PermissionsMixin from "@/mixin/permissionsMixin";

    export default {
        components: {Pagination, PulseLoader},
        mixins: [goBackButtonMixin, PermissionsMixin],
        name: 'MainComponent',
        data() {
            return {
                loading: false,
                editMode: false,
                isPrinting: false,
                appName: process.env.VUE_APP_NAME,
                vesselName: auth.getVesselName(),
                permissions: auth.getPermissionData(),
                printItems: [],
                query: '',
                queryFiled: 'name',
                departments: [],
                mainComponent: [],
                excelHeader: [],
                excelData: [],
                selectedDepartment: null,
                departmentId: '',
                searchInput: '',
                offset: 20,
                form: new Form({
                    id: '',
                    name: '',
                    department_id: '',
                    code: '',
                    critical_equipment: '',
                    vessel_id: auth.getVesselId(),
                    status: 'Activate'
                }),
                vessel_id: auth.getVesselId(),
                pagination: {
                    current_page: 1
                }
            }
        },
        watch: {
            'form.department_id': function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.form.code = this.updateCode(newVal, this.departments);
                }
            },
        },
        mounted() {
            this.departmentList()
            this.getData()
        },
      computed: {
        getTableClasses() {
          return {
            'table': true,
            'text-center': true,
            'table-striped': !this.isPrinting,
            'table-bordered': !this.isPrinting,
            'table-sm': !this.isPrinting,
            'print-table': this.isPrinting,
          };
        }
      },
        methods: {
            updateCode(itemId, components) {
                const selectedComponent = components.find(component => component.id === itemId);
                if (selectedComponent && selectedComponent.code) {
                    return selectedComponent.code + '-';
                }
                return '';
            },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Main Component': `${item?.name || ''}`,
                'Department Name': `${item?.department?.name || ''}`,
                'Code': `${item?.code || ''}`,
                'Critical Equipment': `${item?.critical_equipment ==  1 ? 'Yes' : 'No'}`,
                'Status': `${item?.status == 'Activate' ? 'Active' : 'Inactive'}`,
              });
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                is_all: 1,
                department_id : this.departmentId,
                search : this.searchInput,
                offset : this.offset,
              };

              const res = await this.$http.get('/api/filter/main-component/' + this.vessel_id, {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Main Component List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },


          onPerPageChange() {
            this.getData(1);
          },

            getData(page = 1) {
                  var params = {
                    page: page,
                    is_all: 0,
                    department_id : this.departmentId,
                    search : this.searchInput,
                    offset : this.offset,
                  }
                this.loading = true
                this.$http.get('/api/filter/main-component/' + this.vessel_id, {params}).then(response => {
                    this.loading = false
                    this.mainComponent = response.data.success
                }).catch(e => {
                    this.loading = false
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },
            create() {
                this.editMode = false
                this.form.reset()
                this.form.clear()
                $('#roleModal').modal('show')
            },
            store() {
                this.form.busy = true
                this.form.critical_equipment = this.form.critical_equipment == true ? 1 : 0;
                this.form.post('/api/main-component').then(response => {
                    $('.dataTables_empty').closest('tr').remove()
                    this.getData(Number(this.mainComponent?.current_page))
                    $('#roleModal').modal('hide')
                    if (this.form.successful) {
                        this.$snotify.success('Main Component Created Successfully')
                    } else {
                        this.$snotify.error('Something went wrong try again later.')
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {
                        var error = this.form.errors.errors.error
                        this.$snotify.error(error)
                    }

                })
            },

            edit(component) {
                this.editMode = true
                this.form.reset()
                this.form.clear()
                this.form.fill(component)
                setTimeout(() => {
                    this.form.code = component.code
                }, 1000)
                $('#roleModal').modal('show')
            },
            update() {
                this.form.busy = true
                this.form._method = 'put';
                this.form.critical_equipment = this.form.critical_equipment == true ? 1 : 0;
                this.form.post('/api/main-component/' + this.form.id).then(response => {
                  this.getData(Number(this.mainComponent?.current_page))
                  $('#roleModal').modal('hide')
                    if (this.form.successful) {
                        this.$snotify.success('Main component successfully Update')
                    } else {
                        this.$snotify.error('Something went wrong try again later.', 'Error')
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },
            destroy(mainComponent) {
                this.$dialog.confirm('Do You Want to delete This ?').then(() => {
                    this.$http.delete('/api/main-component/' + mainComponent.id).then(response => {
                      this.getData(Number(this.mainComponent?.current_page))
                      this.$snotify.success('Main Component Successfully Deleted')
                    }).catch(e => {
                        let response = e.response;
                        if (response.status === 403) {
                            this.$snotify.warning(response?.data?.error)
                        } else {
                            let response = e.response?.data
                            this.$snotify.error(
                                response?.error,
                                'error'
                            )
                        }
                    })
                }).catch(function () {
                    console.log(e)
                })
            },
            departmentList() {
               let params = {
                 is_all : 1
               }
                this.$http.get('/api/filter/department/' + this.vessel_id, {params}).then(response => {
                    this.departments = response.data.success
                }).catch(e => {
                    console.log(e)
                })
            },
            goBack() {
                this.$router.go(-1);
            },
        }
    }
</script>

<style scoped>

</style>
